/*-----------------------------------------------------------------
- Referral program
-----------------------------------------------------------------*/

export default {
    title             : 'Referral program',
    full_name         : 'Full Name',
    email_address     : 'Email Address',
    phone_number      : 'Mobile Phone Number',
    country           : 'Residence Country',
    message           : 'Message',
    submit            : 'Submit',
    show_more         : 'Show More',
    submit_success_msg: 'Thank you for submitting the form!\nOne of our agents will get back to you in the next 24 hours.',
};
